import { useTheme, css } from 'styled-components';

import { useBuilderConfigContext } from 'hb-builder/contexts/BuilderConfigContext';
import { INITIAL_FONTS, loadFont } from 'hb-builder/utils/fonts';
import { getCustomFontName } from 'hb-react/backoffice/components/PageBuilder/utils/getCustomFontName';
import Select from 'hb-react/shared/components/DesignSystem/Inputs/Select';
import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const FontTool = ({ fonts, onItemClick, value }) => {
  const theme = useTheme();
  const {
    hivebrite: { networkTheming },
  } = useBuilderConfigContext();
  const { quillRef } = useQuillEditorContext();

  const handleChangeFontFamily = (e) => {
    const value = e?.target.value;
    const customFontName = getCustomFontName(networkTheming);

    if (value && customFontName !== value) {
      loadFont(value);
    }
    quillRef.current.format('customFontFamily', value, 'user');
  };

  return (
    <ToolbarItem
      css={css`
        width: 50%;
      `}
      isActive
    >
      <Select
        fontSize={13}
        height={25}
        hideLabel
        iconSpaceRight={theme.space[2]}
        id="builder-selection-font-family"
        label={__('Font family')}
        lineHeight={1.4}
        name="font-family"
        onChange={handleChangeFontFamily}
        onClick={onItemClick}
        options={fonts}
        value={value || INITIAL_FONTS[0]}
        size="extra-small"
        width="100%"
      />
    </ToolbarItem>
  );
};

FontTool.getFormat = (format, quill, fonts) =>
  format?.customFontFamily ||
  window
    .getComputedStyle(quill.container)
    .fontFamily.split(',')
    .map((v) => v.trim())
    .find((v) => (fonts.map((font) => font.text) || INITIAL_FONTS).includes(v));

export default FontTool;
